module.exports = __webpack_public_path__ + "static/scale-model-of-dallas-texas-ad130747f51cb3bc07c3f0120ec7af85.png";